import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField } from '@mui/material';

interface IConfirmationInputDialog {
  title: string,
  dialogText: string,
  isOpen: boolean,
  inputLengthRequirement: number,
  setOpen: React.Dispatch<React.SetStateAction<boolean>>,
  confirm: (input: string) => void,
  actionButtonText: string,
}

function ConfirmationInputDialog({
  title,
  dialogText,
  isOpen,
  inputLengthRequirement,
  setOpen,
  confirm,
  actionButtonText,
}: IConfirmationInputDialog) {
  const [input, inputChanged] = React.useState('');
  const handleClose = () => {
    setOpen(false);
  };
  const handleConfirm = () => {
    setOpen(false);
    confirm(input);
  };

  const handleInputChanged = (value: string) => {
    inputChanged(value);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
    >
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {dialogText}
        </DialogContentText>
        <TextField
          autoFocus
          required
          fullWidth
          label="Please provide a reason here."
          variant="standard"
          onChange={(e: { target: { value: string; }; }) => { handleInputChanged(e.target.value); }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>Cancel</Button>
        <Button disabled={!(input.length > inputLengthRequirement)} onClick={handleConfirm} color="error">
          {actionButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationInputDialog;
